module.exports = __webpack_public_path__ + "static/media/menu.10567aa7.svg";